export default {
  status: {
    success: 'Não há dados para exibir.',
    error: 'Erro ao carregar dados.',
  },
};
